<template>
  <div>
    <div class="plansDisplay">
      <div class="cardBlk">
        <div class="cardSec">
          <div
            :class="[
                {
                    typeOne: typeOne,
                    hasWow:selected === index,
                    cardWrap: !plan.image || !getPlan(plan.id)[0].offerImage['_180wide']
                },
            ]"
            v-for="(plan, index) in offer"
            :key="plan.id"
            @click="setActive(index, getPlan(plan.id), plan.name)"
          >
            <div
              v-if="plan.image === true && getPlan(plan.id)[0].offerImage['_180wide']"
              class="offerBlk"
            >
              <img
                class="offerImageDesk"
                :src="getPlan(plan.id)[0].offerImage['_180wide'] "
                alt="loading..."
              />
              <img
                class="offerImageMobile"
                :src="getPlan(plan.id)[0].offerImage['_282wide'] "
                alt="loading..."
              />
            </div>
            <div
              v-if="!plan.image || !getPlan(plan.id)[0].offerImage['_180wide'] "
              class="plansWrapper"
            >
              <div class="planHeader">
                <template>
                  <p v-if="getPlan(plan.id)[0].interval == 'year'" class="wow">
                    BEST DEAL
                    SAVE 50%
                  </p>
                  <div class="currency">
                    {{
                    getCurrency(getPlan(plan.id)[0].currency)
                    }}{{
                    (getPlan(plan.id)[0].amount / 12).toString().split(".")[0]
                    }}.
                    <span
                      class="cents"
                    >
                      {{
                      (Math.ceil((getPlan(plan.id)[0].amount / 12) * 20) / 20)
                      .toFixed(2)
                      .toString()
                      .split(".")[1]
                      }}
                    </span>
                    <p class="fullPrice">per month</p>
                  </div>
                  <div class="trail" v-if="plan.trial">{{ plan.trial }} DAYS FREE TRIAL</div>
                </template>
              </div>
              <div class="continue-blk">
                <div class="bar"></div>
                <p>
                  {{ getCurrency(getPlan(plan.id)[0].currency)}}{{ getPlan(plan.id)[0].amount }}
                  {{ getBilling(getPlan(plan.id)[0].interval) }}
                </p>
                <p>Cancel Anytime</p>
              </div>
            </div>
          </div>
        </div>
        <div
          v-if="typeOne || selectedPlans"
          class="neouButton"
          :class="{ fluid: typeOne }"
          @click="callContinue"
        >continue</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "PlanVariantB",
  data: () => ({
    fetchingPlans: true,
    selected: undefined,
    selectedPlans: "",
    title: ""
  }),
  methods: {
    callContinue() {
      this.$emit("onChange", this.selectedPlans, this.titles);
    },
    handlePlanSelected() {
      // if (selectedPlan.length == 1) {
      //   selectedPlan = selectedPlan[0];
      // }
      this.selectedPlans[0]["name"] = this.titles;
      this.$emit("selectedPlan", this.selectedPlans[0]);
      window.dataLayer.push({
        event: "select_plan",
        plan_id: this.selectedPlans[0].id
      });
      this.$emit("nextScreen");
    },
    setActive(index, selectedPlan, title) {
      this.titles = title;
      this.selectedPlans = selectedPlan;
      this.selected = index;
    },
    getPlan: function(planToFind) {
      let prices = [];
      this.plans.forEach(plan => {
        prices.push(...plan.plans);
      });
      return prices.filter(price => {
        return price.id == planToFind;
      });
    },
    getCurrency: function(currency) {
      if (currency == "usd") {
        return "$";
      }
      if (currency == "gbp") {
        return "£";
      }
      if (currency == "cad") {
        return "$";
      }
      if (currency == "aud") {
        return "$";
      }
    },
    getBilling: function(interval) {
      if (interval == "year") {
        return "billed annually";
      }
      if (interval == "month") {
        return "billed monthly";
      }
    },
    isPlanSelected: function() {
      if (
        typeof window.selectedPlan !== undefined &&
        window.preserveCheckout !== false
      ) {
        // this.handlePlanSelected(
        //   this.getPlan(window.selectedPlan.id),
        //   window.selectedPlan.name
        // );
      }
    }
  },
  props: {
    landscape: String,
    typeOne: Boolean,
    plans: Array,
    offer: Array
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.cardSec {
  display: flex;
  justify-content: center;
  flex-direction: row;
  align-items: center;
}
.offerImageDesk {
  width: 150px;
  // display: none;
}
.offerImageMobile {
  width: 282px;
  display: none;
}
.offerBlk {
  cursor: pointer;
  padding: 10px;
}
.cardBlk {
  .plansWrapper {
    display: flex;
    flex-direction: column;
    justify-content: space-evenly;
    height: 100%;
    margin: 0;
  }
  .cardWrap {
    width: 140px;
    height: 184px;
    cursor: pointer;
    margin: 15px 5px 15px;
    border-radius: 7.52px;
    border: solid 3px #ffffff;
    background: #f3f5f7;
    position: relative;
    z-index: 999;
    &.hasWow {
      border: 3px solid #30e1fe;
    }
  }
  .currency {
    // height: 60px;
    color: #12161a;
    font-size: 32px;
    font-family: "prox", Helvetica;
    font-weight: 400;
    line-height: 30px;
    padding-top: 35px;
    text-align: center;
    letter-spacing: -0.1828571px;
    // margin-bottom: 12px;
  }
  .continue-blk {
    p {
      font-size: 10px;
      margin: 0;
      color: #12161a;
      text-align: center;
      font-weight: 400;
    }
  }
  .neouButton {
    font-size: 15px;
    width: 290px;
    height: 48px;
    margin: 0 auto;
    padding: 15px;
    color: #12161a;
    text-align: center;
    letter-spacing: 0.5px;
    font-weight: 400;
    margin-bottom: 8px;
  }
  .bar {
    width: 109px;
    margin: 10px auto;
    border: solid 1px #dfdfdf;
  }
  .fullPrice {
    height: 18px;
    color: #717171;
    font-size: 12px;
    font-weight: 400;
    line-height: 18px;
    text-align: center;
    margin: 0;
  }
  .trail {
    height: 16px;
    color: #12161a;
    font-size: 11.5px;
    font-weight: 400;
    line-height: 17px;
    text-align: center;
    letter-spacing: 0.2px;
  }
  .wow {
    background-color: #222a31;
    border-top-left-radius: 6px;
    border-top-right-radius: 6px;
    font-size: 11px;
    line-height: 1.125em;
    text-transform: uppercase;
    font-weight: 400;
    padding: 6px 7px;
    color: #ffffff;
    position: absolute;
    width: 100%;
    left: 0;
    top: 0;
    margin: 0px;
    text-align: center;
    &::before {
      display: block;
      content: "";
      width: 0;
      position: absolute;
      bottom: -8px;
      left: 0;
      height: 0;
      border-style: solid;
      border-width: 8px 69px 0 69px;
      border-color: #222a31 transparent transparent transparent;
      line-height: 0px;
      _border-color: #222a31 #000000 #000000 #000000;
      _filter: progid:DXImageTransform.Microsoft.Chroma(color='#000000');
    }
  }
}
@media screen and (min-width: 768px) {
  .offerImageDesk {
    display: block;
  }
  .offerImageMobile {
    display: none;
  }
  // .cardSec {
  //   flex-direction: row;
  // }
}
</style>